import { observer } from 'mobx-react-lite'

import { PlainBrandIcon } from '@jotta/ui/BrandIcon'

import { ShareAlbumDialog } from '../Album/Dialogs/ShareAlbumDialog'

import type { PhotoActionHandlerActionProps } from './PhotoActionHandlers'

export const ActionShareAlbum = observer<
  PhotoActionHandlerActionProps<'SHARE_ALBUM'>
>(function ActionShareAlbum({
  action,
  albumId,
  buttonClass,
  onActionDialogClose,
  disabled = false,
}) {
  if (!albumId) {
    return null
  }

  return (
    <ShareAlbumDialog
      albumId={albumId}
      disabled={disabled}
      onOpenChange={open => {
        if (!open && onActionDialogClose) {
          onActionDialogClose(action.actionType)
        }
      }}
      triggerElement={
        <button className={buttonClass}>
          <PlainBrandIcon icon={action.icon} />
          <span>{action.label}</span>
        </button>
      }
    />
  )
})
